
const projectsServicesConstants = {
    GET_PROJECTS : "sql_projects", //get
    INSERT_PROJECT: "insertProject", //post
}

export {
    projectsServicesConstants,
}